import styled from 'styled-components';
import { motion } from 'framer-motion';
import { SlideableCarouselItem } from '@comeon/ui';
import { BannerContextProvider, BannerContextProviderProps } from './context/banner-context';
import { eCommerceCampaignClick } from '~/components/promotions/ducks';
import ContentGrid from './partials/content-grid';
import BackgroundImage from './partials/background-image';
import ForegroundImage from './partials/foreground-image';
import SecondForegroundImage from './partials/second-foreground-image';
import TextGroup from './partials/text-group';
import Terms from './partials/terms';

interface WrapperProps {
	isTermsEnabled: boolean;
	hasUrl: boolean;
}

const Wrapper = styled(motion.div)<WrapperProps>`
	display: grid;
	grid-template-columns: 1fr;
	grid-template-rows: ${({ isTermsEnabled }) => (isTermsEnabled ? '1fr min-content' : '1fr')};
	grid-template-areas: ${({ isTermsEnabled }) => (isTermsEnabled ? "'banner' 'terms'" : "'banner'")};
	height: 100%;
	position: relative;
	overflow: hidden;
	cursor: ${({ hasUrl }) => (hasUrl ? 'pointer' : 'default')};
`;

const carouselItemClick = (title: string, id: number, index: number, url: string, externalWindow: boolean) => {
	eCommerceCampaignClick(title, id, index);
	window.open(url, externalWindow ? '_blank' : '_self');
};

const Banner: React.FC<BannerContextProviderProps> = props => {
	const {
		data: { tcText, url, headerText, id, openNewWindow, name },
		index
	} = props;

	const onTap = () => {
		if (url) {
			carouselItemClick(headerText || name || '', id, index, url, openNewWindow);
		}
	};

	return (
		<BannerContextProvider {...props}>
			<SlideableCarouselItem>
				<Wrapper isTermsEnabled={!!tcText} hasUrl={!!url} role="link" tabIndex={0} onTap={onTap}>
					<BackgroundImage />
					<ContentGrid>
						<ForegroundImage />
						<SecondForegroundImage />
						<TextGroup />
					</ContentGrid>
					<Terms />
				</Wrapper>
			</SlideableCarouselItem>
		</BannerContextProvider>
	);
};

export default Banner;
